import Cookies from 'js-cookie';

/**
 * FFH-359: the direct Meta pixel event functions (PageView / ViewContent /
 * Lead / AddToCart / Purchase) were removed — those pixels now fire from the
 * GTM container off the dataLayer, deduped with the server CAPI on a shared
 * event_id. What remains are the first-party click/browser-id readers consumed
 * by the dataLayer rail (`readClickIds`) and the checkout page, plus the
 * localStorage key that carries the purchase dedup id.
 */

export const trackingPurchasePixelIDKey = 'tracking_purchase_pixelEventId';

const FACEBOOK_CLICK_ID_COOKIE_NAME = '_fbc';

export const getFacebookClickId = () => {
  const fbClickId = Cookies.get(FACEBOOK_CLICK_ID_COOKIE_NAME);
  if (fbClickId) {
    return fbClickId;
  }
  return null;
};

export const getFacebookBrowserId = (document) => {
  const fbpCookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith('_fbp='))
    ?.split('=')[1];
  return fbpCookie || null;
};
